/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import { Fragment, PureComponent } from 'react';
import { callIfPossible } from 'UIComponents/core/Functions';
import { InsertVideoIcon } from 'foundations-assets';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import GoVideoDialog from './GoVideoDialog';
import GoVideoPopover from './GoVideoPopover';
import SmallToggleButton from './components/SmallToggleButton';
import { fetchUserSetting, saveUserSetting } from './api/UserSettingsApi';
import { VIDEO_CONSTANTS } from './utils/constants';
import createUnstyledPluginButton from './utils/createUnstyledPluginButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACADEMY_RESOURCES_URL = 'https://academy.hubspot.com/lessons/personalized-video';
const {
  HAS_VIEWED_VIDEO_INTEGRATION_SHEPHERD
} = VIDEO_CONSTANTS;
export const createInsertVideoButton = ({
  useUnstyledButton = false,
  useInsertPopover = false,
  insertPopoverPlacement = 'top left',
  usePopover = false,
  shepherdUserSettingKey = HAS_VIEWED_VIDEO_INTEGRATION_SHEPHERD,
  handleVideoTracking = {},
  isInlineVideo = false,
  showTitleCheckBox = false,
  CustomButtonComponent
} = {}) => {
  const TICKET_OBJECT_TYPE = 'TICKET';
  class InsertVideoButton extends PureComponent {
    constructor(props) {
      super(props);
      this.handleClose = this.handleClose.bind(this);
      this.handleOpen = this.handleOpen.bind(this);
      this.renderShepherdPopoverContent = this.renderShepherdPopoverContent.bind(this);
      this.handleOpenFromShepherdPopover = this.handleOpenFromShepherdPopover.bind(this);
      this.handleCloseShepherdPopover = this.handleCloseShepherdPopover.bind(this);
      this.trackingTimeout = null;
      this.state = {
        hasSeenVideoIntegrationShepherd: true,
        open: false
      };
    }
    componentDidMount() {
      fetchUserSetting(shepherdUserSettingKey).then(({
        hasSeenVideoShepherd
      }) => {
        const hasSeenVideoIntegrationShepherd = hasSeenVideoShepherd == null ? false : hasSeenVideoShepherd;
        this.setState({
          hasSeenVideoIntegrationShepherd
        });
      }).catch(() => {
        console.warn('Failed to fetch user setting');
      });
    }
    componentWillUnmount() {
      if (this.trackingTimeout) {
        window.clearTimeout(this.trackingTimeout);
      }
    }
    handleOpenFromShepherdPopover() {
      callIfPossible(handleVideoTracking.openVidyardModalFromShepherd);
      this.handleOpen();
      this.handleHasSeenVideoIntegrationShepherd();
    }
    handleCloseShepherdPopover() {
      callIfPossible(handleVideoTracking.closeShepherdPopover);
      this.handleHasSeenVideoIntegrationShepherd();
    }
    handleHasSeenVideoIntegrationShepherd() {
      if (this.state.hasSeenVideoIntegrationShepherd) {
        return;
      }
      saveUserSetting(shepherdUserSettingKey, 'hasSeenVideoShepherd', true).then(() => this.setState({
        hasSeenVideoIntegrationShepherd: true
      })).catch(() => {
        console.warn('Failed to save user setting');
      });
    }
    handleClose() {
      if (this.trackingTimeout) {
        window.clearTimeout(this.trackingTimeout);
      }
      this.setState({
        open: false
      });
    }
    handleOpen() {
      if (!this.state.hasSeenVideoIntegrationShepherd) {
        this.trackingTimeout = setTimeout(() => callIfPossible(handleVideoTracking.vidyardModalOpen10Secs), 10000);
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'open' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.setState(({
        open
      }) => ({
        open: !open
      }));
      callIfPossible(handleVideoTracking.openedVideo);
    }
    renderShepherdPopoverContent() {
      return {
        header: /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "draftPlugins.videoPlugin.popover.header"
          })
        }),
        body: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "draftPlugins.videoPlugin.popover.body"
          }), ' ', /*#__PURE__*/_jsx(Link, {
            href: ACADEMY_RESOURCES_URL,
            target: "_blank",
            onClick: () => callIfPossible(handleVideoTracking.clickAcademyResources),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "draftPlugins.videoPlugin.popover.bodyLink"
            })
          })]
        }),
        footer: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Button, {
            use: "primary",
            onClick: this.handleOpenFromShepherdPopover,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "draftPlugins.videoPlugin.popover.acceptButton"
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: this.handleCloseShepherdPopover,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "draftPlugins.videoPlugin.popover.closeButton"
            })
          })]
        })
      };
    }
    renderButton() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideVideoShepherd' does not exist on typ... Remove this comment to see the full error message
      const {
        hideVideoShepherd
      } = this.props;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasSeenVideoIntegrationShepherd' does no... Remove this comment to see the full error message
      const {
        hasSeenVideoIntegrationShepherd
      } = this.state;
      if (CustomButtonComponent) {
        return /*#__PURE__*/_jsx(CustomButtonComponent, {
          onClick: this.handleOpen
        });
      }
      if (useUnstyledButton) {
        const text = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.videoPlugin.video"
        });
        const VideoButton = createUnstyledPluginButton({
          text
        });
        return /*#__PURE__*/_jsx(VideoButton, {
          onClick: this.handleOpen
        });
      }
      if (usePopover && !hasSeenVideoIntegrationShepherd && !hideVideoShepherd) {
        return /*#__PURE__*/_jsx(Popover, {
          use: "shepherd",
          open: true,
          content: this.renderShepherdPopoverContent(),
          children: /*#__PURE__*/_jsx(Button, {
            use: "unstyled",
            children: /*#__PURE__*/_jsx(InsertVideoIcon, {})
          })
        });
      }
      return /*#__PURE__*/_jsx(SmallToggleButton, {
        active: false,
        icon: InsertVideoIcon,
        onClick: this.handleOpen,
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "draftPlugins.videoPlugin.tooltip"
        }),
        tooltipPlacement: "bottom"
      });
    }
    renderModal() {
      const {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
        editorState,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'objectType' does not exist on type 'Read... Remove this comment to see the full error message
        objectType,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
        onChange,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'recipientEmail' does not exist on type '... Remove this comment to see the full error message
        recipientEmail,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'useProsemirror' does not exist on type '... Remove this comment to see the full error message
        useProsemirror
      } = this.props;
      if (!this.state.open) {
        return null;
      }
      return /*#__PURE__*/_jsx(GoVideoDialog
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ editorState: any; isInServiceHub: boolean;... Remove this comment to see the full error message
      , {
        editorState: editorState,
        isInServiceHub: objectType === TICKET_OBJECT_TYPE,
        onClose: this.handleClose,
        onChange: onChange,
        trackingHandlers: handleVideoTracking,
        recipientEmail: recipientEmail,
        isInlineVideo: isInlineVideo,
        showTitleCheckBox: showTitleCheckBox,
        useProsemirror: useProsemirror
      });
    }
    render() {
      const {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorState' does not exist on type 'Rea... Remove this comment to see the full error message
        editorState,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
        onChange,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'recipientEmail' does not exist on type '... Remove this comment to see the full error message
        recipientEmail,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'useProsemirror' does not exist on type '... Remove this comment to see the full error message
        useProsemirror
      } = this.props;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'open' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      const {
        open
      } = this.state;
      if (useInsertPopover) {
        return /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(GoVideoPopover, {
            recipientEmail: recipientEmail
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            ,
            editorState: editorState,
            isInServiceHub: this.props.objectType === TICKET_OBJECT_TYPE,
            onChange: onChange,
            onClose: this.handleClose,
            open: open,
            placement: insertPopoverPlacement,
            trackingHandlers: handleVideoTracking,
            isInlineVideo: isInlineVideo,
            showTitleCheckBox: showTitleCheckBox,
            useProsemirror: useProsemirror,
            children: this.renderButton()
          })
        });
      }
      if (CustomButtonComponent) {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [this.renderButton(), this.renderModal()]
        });
      }
      return /*#__PURE__*/_jsxs("div", {
        children: [this.renderButton(), this.renderModal()]
      });
    }
  }
  InsertVideoButton.defaultProps = {
    hideVideoShepherd: false,
    useProsemirror: true
  };
  return InsertVideoButton;
};